// This file should only contain action type constants.

export const SET_COUNTS = 'SET_COUNTS';
